import { ColumnsType } from '../constants/columnsType';
import { timeHelper } from './timeHelper';
import { maskName } from './maskName';
import { exchangeAmountByRate } from './exchangeAmountByRate';

export const ActionsByColumnsType = {
  [ColumnsType.Default]: (value) => value,
  [ColumnsType.DateFormat]: (value) => timeHelper(value),
  [ColumnsType.MaskNameFormat]: (value) => maskName(value),
  [ColumnsType.ConvertType]: (value, additionalParams) => exchangeAmountByRate(additionalParams),
};
